/*
*   @site           Preloaded: Site
*   @function       Module: Item Index (Used on work, but might be needed for Blog later)
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------
import ItemController from '../_controllers/ItemController';
import ModuleTemplate from '../_templates/ModuleTemplate';


//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleItemIndex extends ModuleTemplate {

  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Vars
    this.config = {
      filter: '',
      itemsPerPage: 9,
      rowsPerPage: 3
    };

    //Custom layouts for short numbers (1-9)
    this.layoutsFixed = [
      [],
      ['12'], //1
      ['12', '12'], //2
      ['12', '12', '12'], //3
      ['12', '12', '6_6'], //4
      ['12', '8_4', '6_6'], //5
      ['6_6', '8_4', '6_6'], //6
      ['8_4', '6_6', '4_4_4'], //7
      ['6_6', '4_4_4', '4_4_4'], //8
    ];

    //Layouts for over 9 items
    this.layoutsOther = [
      ['12', '6_6'], //column count %3 = 0 (i.e. 3, 6, 9, 12 etc.)
      ['8_4', '6_6'],  //column count %3 = 1 (i.e. 4 or 7 etc.)
      ['12', '8_4', '6_6'] //column count %3 = 2 (i.e. 5 or 8 etc.)
    ];

    //Listen for pop state
    addEventListener('popstate', (event) => {
      this.filter();
    });

    //Setup the category nav
    this.bindCategoryButtons();

    //Bind load more
    this.bindLoadMoreButton();

    //Index the items
    this.indexItems();

    //Setup the first filter
    this.filter(); //could we calculate the filter from the current URL (probably)
  }

  //-----------------------------------------------
  // Bind category buttons
  //-----------------------------------------------
  bindCategoryButtons() {
    //List
    this.categories = {};

    //Find
    let buttons = this.element.querySelectorAll('.categories .buttons .button');
    let buttonID;
    for(let i = 0; i < buttons.length; i++) {
      //ID
      buttonID = buttons[i].getAttribute('data-id');
      
      //Bind
      buttons[i].addEventListener('click', function(id, event) {
        this.categoryClick(id);
      }.bind(this, buttonID));

      //Add to list
      this.categories[buttonID] = {
        id: buttonID,
        element: buttons[i]
      };
    }
  }


  //-----------------------------------------------
  // Bind load more button
  //-----------------------------------------------
  bindLoadMoreButton() {
    this.loadMoreHolder = this.element.querySelector('.load-more');
    this.loadMoreButton = this.loadMoreHolder.querySelector('.button');
    this.loadMoreButton.addEventListener('click', () => {
      this.showNextRows();
    });
  }


  //-----------------------------------------------
  // Index all page items
  //-----------------------------------------------
  indexItems() {
    //List
    this.items = [];

    //Find
    let list = this.element.querySelectorAll('.item-index');
    for(let i = 0; i < list.length; i++) {
      this.items.push({
        element: list[i],
        categories: (list[i].getAttribute('data-categories') + ',all').split(','),
      });
    }
  }


  //-----------------------------------------------
  // Calculate the category
  //-----------------------------------------------
  calculateCategory() {
    let parts = document.location.href.split(this.element.getAttribute('data-page-base-url'));
    parts = parts[parts.length - 1].split('/'); 
    return (parts.length > 1 && parts[1] !== '' && this.categories[parts[1]]) ? parts[1] : 'all';
  }


  //-----------------------------------------------
  // Category Click
  //-----------------------------------------------
  categoryClick(id) {
    let url = (id === 'all') ? this.element.getAttribute('data-page-base-url') + '/' : this.element.getAttribute('data-page-base-url') + '/' + id;
    history.pushState({}, '', url);
    this.filter();
  }


  //-----------------------------------------------
  // Filter
  //-----------------------------------------------
  filter() {
    //Calcualte the category from the url
    let category = this.calculateCategory();

    //Act
    if(category !== this.config.filter) {
      //Find relavent items
      let filteredList = [];
      for(let i = 0; i < this.items.length; i++) {
        this.items[i].element.classList.add('hidden');
        this.items[i].element.classList.remove('active', 'first-row', 'delay-1', 'delay-2', 'delay-3');
        if(this.items[i].categories.indexOf(category) > - 1) {
          filteredList.push(i);
        } 
      }

      //Create a row/grid structure based on the length of the filtered list
      this.grid = {
        rows: this.calculateLayout(filteredList),
        currentRow: 0
      };
      
      //Show the first rows of items on a tiny delay to allow the animation to happen
      this.showNextRows();
      
      //Old off
      if(this.categories[this.config.filter]) {
        this.categories[this.config.filter].element.classList.remove('selected');
      }

      //Store new category and select the button
      this.config.filter = category;
      if(this.categories[this.config.filter]) {
        this.categories[this.config.filter].element.classList.add('selected');
      }
    }
  }



  //-----------------------------------------------
  // Calculate the layout for the given grid
  //-----------------------------------------------
  showNextRows() {
    //Loop
    for(let i = 0; i < this.config.rowsPerPage; i++) {
      if(this.grid.rows[this.grid.currentRow]) {
        //Reveal the row
        let row = this.grid.rows[this.grid.currentRow];
        for(let j = 0; j < row.items.length; j++) {
          this.items[row.items[j]].element.classList.remove('hidden');
          this.items[row.items[j]].element.classList.add('delay-' + (j + 1));

          setTimeout(() => {
            this.items[row.items[j]].element.classList.add('active');
          }, 50);

          //If this is the first item in the first row, then scroll to it!
          if(i === 0 && j === 0 && this.grid.currentRow > 0) {
            this.items[row.items[j]].element.scrollIntoView({
              behavior: 'smooth'
            });
          }

          //First row
          if(this.grid.currentRow  === 0) {
            this.items[row.items[j]].element.classList.add('first-row');
          }
        }

        //Inc
        this.grid.currentRow++;
      }
    }

    //Load more button on/off
    if(!this.grid.rows[this.grid.currentRow]) {
      this.loadMoreHolder.classList.add('hidden');
    } else {
      this.loadMoreHolder.classList.remove('hidden');
    }

    //Check title heights for the new items
    ItemController.setTitleHeights();
  }


  //-----------------------------------------------
  // Calculate the layout for the given grid
  //-----------------------------------------------
  calculateLayout(items) {
    //Vars
    let rows = [];
    let columns, row;
    let layout = [];
    let item;
    let itemIndex;

    //Find a matching layout or create one
    if(items.length < this.layoutsFixed.length) {
      //Stored layout
      rows = this.layoutsFixed[items.length];
    } else {
     
      //Add the moasic part
      let itemCount =  items.length;
      for(let i = 0; i < this.layoutsOther[items.length % 3].length; i++) {
        rows.push(this.layoutsOther[items.length % 3][i]);
        itemCount -= this.layoutsOther[items.length % 3][i].split('_').length;
      }
      let defaultRowCount =  Math.ceil(itemCount / 3);

      //Finish the layout with standard rows
      for(let i = 0; i < defaultRowCount; i++) {
        rows.push('4_4_4');
      }
    }
    
    //Now we know the layout, we can fit the items in and return it all
    for(let i = 0; i < rows.length; i++) {
      //New row
      row = {
        items: [],
        layout: rows[i]
      };
      columns = rows[i].split('_');
    
      //Loop through the items
      for(let j = 0; j < columns.length; j++) {
        //Item ID
        itemIndex = items.splice(0, 1)[0];

        //Target the item in our list
        item = this.items[itemIndex].element;
        item.classList.remove('col-sm-4', 'col-sm-6', 'col-sm-8', 'col-sm-12');
        item.classList.add('col-sm-' + columns[j]);

        //Add the item ID to the row
        row.items.push(itemIndex);
      }

      //Add to the layout
      layout.push(row);
    }

    //Return
    return layout;
  }
}